import { Routes } from '@angular/router';

export const full: Routes = [  
  { 
    path: 'sesiones', 
    loadChildren: () => import('../../features/sesiones/sesiones.module').then(e => e.SesionesModule),
    data: { title: 'Sesion'} 
  }

];
